/**
 * Les rubriques de l'application : barre latérale, titre mobile, et nom de la
 * rubrique sur l'écran « Disponible avec l'offre complète ».
 */

import {
    LayoutDashboard,
    FileText,
    ArrowDownCircle,
    Calculator,
    Users,
    ClipboardList,
    Briefcase,
    BookOpen,
    HardHat,
    Bell,
    Landmark,
    Shield,
    Inbox,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { User } from '@/types';

export interface NavItem {
    to: string;
    icon: LucideIcon;
    label: string;
    module?: keyof Pick<User, 'moduleCatalogue' | 'moduleSousTraitance' | 'moduleRelances'>;
}

export interface NavGroup {
    label?: string;
    items: NavItem[];
}

export const navGroups: NavGroup[] = [
    {
        items: [
            { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
        ],
    },
    {
        label: 'Commercial',
        items: [
            { to: '/clients', icon: Users, label: 'Clients' },
            { to: '/quotes', icon: ClipboardList, label: 'Devis' },
            { to: '/invoices', icon: FileText, label: 'Factures' },
            { to: '/inbound-invoices', icon: Inbox, label: 'Factures reçues' },
        ],
    },
    {
        label: 'Chantiers',
        items: [
            { to: '/projects', icon: Briefcase, label: 'Chantiers' },
            { to: '/expenses', icon: ArrowDownCircle, label: 'Dépenses' },
            { to: '/bank', icon: Landmark, label: 'Banque' },
            { to: '/retentions', icon: Shield, label: 'Retenues' },
            { to: '/relances', icon: Bell, label: 'Relances', module: 'moduleRelances' },
        ],
    },
    {
        label: 'Outils',
        items: [
            { to: '/catalogue', icon: BookOpen, label: 'Catalogue', module: 'moduleCatalogue' },
            { to: '/subcontractors', icon: HardHat, label: 'Sous-traitants', module: 'moduleSousTraitance' },
            { to: '/simulator', icon: Calculator, label: 'Simulateur' },
        ],
    },
];

export const PAGE_TITLES: Record<string, string> = {
    '/dashboard': 'Dashboard',
    '/clients': 'Clients',
    '/quotes': 'Devis',
    '/invoices': 'Factures',
    '/inbound-invoices': 'Factures reçues',
    '/projects': 'Chantiers',
    '/expenses': 'Dépenses',
    '/bank': 'Banque',
    '/retentions': 'Retenues de garantie',
    '/relances': 'Relances',
    '/catalogue': 'Catalogue',
    '/subcontractors': 'Sous-traitants',
    '/simulator': 'Simulateur',
    '/settings': 'Paramètres',
};
